/**
 * Sidebar navigation for the admin panel.
 */

import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Code2,
  LayoutDashboard,
  Users,
  BarChart3,
  LogOut,
  ShieldCheck,
} from 'lucide-react';

const NAV_ITEMS = [
  { to: '/admin', label: 'Overview', icon: LayoutDashboard },
  { to: '/admin/developers', label: 'Developers', icon: Users },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/usage-logs', label: 'Usage Logs', icon: BarChart3 },
  { to: '/admin/metrics', label: 'System Metrics', icon: BarChart3 },
];

export default function AdminSidebar() {
  const { developer, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <aside className="sidebar">
      <Link to="/admin" className="sidebar-brand">
        <Code2 size={28} />
        <span>token-kit</span>
      </Link>

      <div style={{ padding: '16px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
        <ShieldCheck size={14} style={{ color: 'var(--warning)' }} />
        <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--warning)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          Admin Panel
        </span>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className={`sidebar-link ${location.pathname === to ? 'active' : ''}`}
          >
            <Icon size={18} />
            <span>{label}</span>
          </Link>
        ))}

      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{developer?.name}</span>
            <span className="sidebar-user-tier">admin</span>
          </div>
        </div>
        <button className="sidebar-link logout-link" onClick={handleLogout}>
          <LogOut size={18} />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
}
